import { IGetBalanceByTypeCodeType, IGetBalanceDetailType, IGetTotalContractByCodeRequestType, IRequestGenerateLeaveType, IRequestType } from "./type"

const leaveBaseUrl = '/employee/leave'
export const LeaveEndpointConst = {
    leaveList: `${leaveBaseUrl}/application/list`,
    applyForLeave: `${leaveBaseUrl}/application`,
    leaveApprovedDeclined: `${leaveBaseUrl}/application/status`,
    addComments: `${leaveBaseUrl}/application/comment`,
    leaveBalanceList: `${leaveBaseUrl}/balance`,
    getEmployeeForGenerateLeave: `${leaveBaseUrl}/generate/remaining`,
    getEmployeeList: `${leaveBaseUrl}/acquired`,
    deleteApplyLeave: `${leaveBaseUrl}/application`,
    getCommentList: `${leaveBaseUrl}/application/comment/list`,
    getSandwishDaysUrl: `${leaveBaseUrl}/application/sandwich-days`,
    calibrateLeave: `${leaveBaseUrl}/balance/calibrate`,
    transactionLeave: `${leaveBaseUrl}/transactions`,
    isLeaveExists: `${leaveBaseUrl}/application/exists`,
}

export const getApplyForLeaveByIdUrl = (params: IRequestType) => {
    return `${leaveBaseUrl}/application/${params.leaveId}`
}
export const addGenerateLeaveByCodeUrl = (params: IRequestGenerateLeaveType) => {
    return `${leaveBaseUrl}/${params.employeeCode}/generate`
}
export const deleteCommentByIdUrl = (params: IRequestType) => {
    return `${leaveBaseUrl}/application/${params.leaveId}/comments`
}
export const getEmployeeLeaveDetailsByIdUrl = (params: IRequestType) => {
    return `${leaveBaseUrl}/application/${params.leaveId}/request/details`
}
export const getEmployeeBalanceDetailsByCodeUrl = (params: IGetBalanceDetailType) => {
    return `${leaveBaseUrl}/application/${params.employeeCode}/balance/details`
}
export const getLeaveBalanceByTypeCodeUrl = (params: IGetBalanceByTypeCodeType) => {
    return `${leaveBaseUrl}/${params.employeeCode}/balance/view`
}
export const getTotalContractByCodeUrl = (params: IGetTotalContractByCodeRequestType) => {
    return `${leaveBaseUrl}/application/${params.employeeCode}/contracts`
}
export const getEmployeeBalanceTransactionsByCodeUrl = (params: IGetBalanceDetailType) => {
    return `${leaveBaseUrl}/${params.employeeCode}/transactions`
}
export const getSyncGoogleCalanderLeaveById = (params: IRequestType) => {
    return `${leaveBaseUrl}/application/google/calander/sync?id=${params.leaveId}`
}